<template>
  <div class="px-4 py-4">
    <div v-if="meta.version === '1' || meta.version === '2' || meta.version==='ext1'">
      <p>
        For more information on how random forests are fit see a standard PRISM report.</p>
    </div>
  </div>
</template>

<script>
import * as portalContent from '@/js/models/portal-content.js';

export default {
  name: 'random-forest-models-drawer',
  data: () => ({}),
  computed: {
    meta() {
      const section_id = "random-forest-models";
      const screen = this.$route.params.screen;
      return portalContent.getVersionMetadata(screen, section_id);
    }
  },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
